import { Component, OnInit } from '@angular/core';
import { Crisp } from 'crisp-sdk-web';

@Component({
  selector: 'app-chat',
  template: ''
})
export class ChatComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    Crisp.configure('03793504-2714-4632-84ac-70aff255297c');
  }

  openChat() {
    Crisp.chat.open();
  }
}
